var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.setFormClass }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checkList,
          expression: "checkList"
        }
      ],
      staticClass: "form-check-input",
      attrs: { type: "checkbox", id: _vm.checkId, disabled: _vm.disabled },
      domProps: {
        value: _vm.value,
        checked: Array.isArray(_vm.checkList)
          ? _vm._i(_vm.checkList, _vm.value) > -1
          : _vm.checkList
      },
      on: {
        click: _vm.updateCheckValue,
        change: function($event) {
          var $$a = _vm.checkList,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = _vm.value,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.checkList = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.checkList = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkList = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "form-check-label", attrs: { for: _vm.checkId } },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31ee98e9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ee98e9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/control/checkbox/Checkbox.vue
// module id = null
// module chunks = 